import EquipmentViewPopup from '../EquipmentViewPopup';

import {Button} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ViewAssetsButton = (props) => {
  const {t} = useTranslation();
  const [visible, setVisible] = React.useState(false);

  return (
    <>
      {!props.contractDetailsError && (
        <div className="assetButtonWrapper">
          <Button
            id="viewAssets"
            variant="text-inline"
            onClick={() => setVisible(!visible)}
          >
            {t('VIEW_ASSETS')}
          </Button>
          <EquipmentViewPopup
            id="EquipmentPopupModal"
            title={t('ASSET_DETAILS')}
            visible={visible}
            setVisible={setVisible}
            selectedContractNumber={props.selectedContractNumber}
            docType={props.docType}
          />
        </div>
      )}
    </>
  );
};

ViewAssetsButton.propTypes = {
  selectedContractNumber: PropTypes.string,
  docType: PropTypes.string,
  contractDetailsError: PropTypes.bool,
};

export const mapStateToProps = (state) => {
  return {
    contractDetailsError: state.appStates.contractDetailsError,
  };
};

export default connect(mapStateToProps)(ViewAssetsButton);
